export const INDEX = '/index'
// PERMISSION
export const PERMISSION_ADMINISTRATOR_MANAGE = '/permission/administrator-manage'
export const PERMISSION_ROLE_GROUP = '/permission/role-group'
export const PERMISSION_MENU = '/permission/menu'
// USER
export const USER_COMPANY_MANAGE = '/user/company-manage'
export const USER_COMPANY_BRAND_MANAGE = '/user/company-brand-manage'
// EXCHANGE
export const EXCHANGE_CHEMISTRY_SELL_MANAGE = '/exchange/chemistry-sell-manage'
export const EXCHANGE_UNIVERSITY_GOODS_INFO_MANAGE = '/exchange/university-goods-info-manage'
// DICTIONARY
export const DICTIONARY_UNIVERSITY_MAINTAIN = '/dictionary/university-maintain'
export const DICTIONARY_COMPANY_JOIN_INFO_MANAGE = '/dictionary/company-join-info-manage'
// NEWS
export const NEWS_SYNC_INFO_MANAGE = '/news/sync-info-manage'
// LOGIN
export const LOGIN = '/login/login'
